import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// widget setup
import 'document-register-element/build/document-register-element'
import vueCustomElement from 'vue-custom-element'
Vue.use(vueCustomElement)

Vue.customElement('map-widget', App)
